import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import type { BonusCampaign } from '../../../@types/api';
import { CAMPAIGN_REWARD_TYPE } from '../../../constants/enums';
import type { CashbackBonusFormValues } from '../../../schema';
import { getCashbackRewardTypeOptions } from '../../../utils/cashbackBonus';
import FormSelect from '../../molecules/FormSelect';

type Props = {
  existingRewardType?: BonusCampaign['rewardType'];
  isEditMode: boolean;
  isFreeSpinsEnabled: boolean;
};

const CashbackRewardTypeSelect = ({ existingRewardType, isEditMode, isFreeSpinsEnabled }: Props) => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext<CashbackBonusFormValues>();
  const [product, rewardType] = useWatch({ control, name: ['product', 'rewardType'] });
  const rewardTypeOptions = getCashbackRewardTypeOptions(isFreeSpinsEnabled, product, existingRewardType);

  useEffect(() => {
    const freeSpinsUnavailable = product !== 'CASINO' || !isFreeSpinsEnabled;

    if (!isEditMode && freeSpinsUnavailable && rewardType === CAMPAIGN_REWARD_TYPE.FREE_SPINS) {
      setValue('rewardType', CAMPAIGN_REWARD_TYPE.REAL_MONEY, { shouldValidate: true });
    }
  }, [isEditMode, isFreeSpinsEnabled, product, rewardType, setValue]);

  return product === 'CASINO' ? (
    <FormSelect
      label='Reward Type'
      name='rewardType'
      control={control}
      error={errors.rewardType}
      options={rewardTypeOptions}
      required
      allowDeselect={false}
      disabled={isEditMode}
    />
  ) : null;
};

export default CashbackRewardTypeSelect;
